import script from "./ProductNutritionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNutritionTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductNutritionTable.vue?vue&type=style&index=0&id=b5f310f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f310f2"]])

export default __exports__